import type { CoorumResearchSettings } from '@coorum-research/shared-common/types/research-setting.type'
import type { UserSession } from '../types/user-session.type'
import { getStorageItem, setStorageItem } from './storage.util'
import { toBase64 } from './string.util'

const researchSessionStorageKeyPrefix = 'coorum-research-session'

/**
 * install scriptから設定されるsettings
 * userIdがoptional
 */
export function getUndefinedableResearchSettings(): CoorumResearchSettings | undefined {
  // console.log('window.parent.coorumResearchSettings: ', window.parent.coorumResearchSettings)
  // console.log('window.coorumResearchSettings: ', window.coorumResearchSettings)
  return window.coorumResearchSettings ?? window.parent.coorumResearchSettings
}

/**
 * WARNING:
 * - 'boot' する前の呼び出さないようにすること。
 * - 何かのfunctionの中で呼び出して、globalな位置で呼び出さないこと。
 */
export function getResearchSettings(): CoorumResearchSettings {
  const settings = getUndefinedableResearchSettings()
  if (!settings) {
    throw new Error('CoorumResearch settings is not found')
  }

  // type的には必須だけど、windowから取得しているのでjs injectなので何かの問題で取得できない可能性があるのでチェックしておく。
  if (!settings.accountId) {
    throw new Error('CoorumResearch settings.accountId is not found')
  }

  return settings
}

function generateStorageKey() {
  const { accountId, memberId } = getResearchSettings()
  const base64MemberId = toBase64(memberId)
  return [researchSessionStorageKeyPrefix, accountId, base64MemberId].join(':')
}

export function getSession() {
  const key = generateStorageKey()
  return getStorageItem<UserSession>(key)
}

/**
 * NOTE: userIdを別途 storage保存する？かそのともこのまま？
 */
export function setSession(session: UserSession) {
  const key = generateStorageKey()
  setStorageItem<UserSession>(key, session)
}
